const slugify = require('slugify');

/**
 *
 * @param {string} sitename Vrbo monikerbrand
 * @param {string} locale Contentful Locale
 * @returns {boolean} utility to help us
 */
function checkIfIsSingaporeButNotEnglish(sitename, locale) {
    return sitename === 'homeaway_sg' && locale !== 'en-SG';
}

function getSlug(string) {
    return slugify(string).toLowerCase();
}

module.exports = {checkIfIsSingaporeButNotEnglish, getSlug};
